import { useEffect, useState } from 'react';
import CarrierBadge from '../carrier/CarrierBadge';
import { JOB_KIND_LABELS, jobKindOf, WORK_FAMILIES, workFamilyOf } from '../../shared/installationProcess';

function fmtDistance(m) {
  if (m == null) return '';
  if (m < 1000) return `${Math.round(m)} متر`;
  return `${(m / 1000).toFixed(1)} کیلومتر`;
}

export default function OfferCard({ offer, onAccept, onDecline, busy }) {
  const [left, setLeft] = useState(() => Math.max(0, Math.round((new Date(offer.expires_at).getTime() - Date.now()) / 1000)));
  useEffect(() => {
    const t = setInterval(() => {
      setLeft(Math.max(0, Math.round((new Date(offer.expires_at).getTime() - Date.now()) / 1000)));
    }, 1000);
    return () => clearInterval(t);
  }, [offer.expires_at]);
  const expired = left <= 0;
  const j = offer.job || {};

  return (
    <div className="inst-card inst-offer">
      <div className="inst-offer-head">
        <span className="inst-offer-badge">پیشنهاد کار جدید</span>
        <span className={`inst-offer-timer ${left <= 10 ? 'is-urgent' : ''}`}>{expired ? 'در حال به‌روزرسانی...' : `${left} ثانیه`}</span>
      </div>
      <div className="inst-offer-addr">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>
        <span>{j.customer_address_text}</span>
      </div>
      <div className="inst-offer-meta">
        <CarrierBadge carrier={j.carrier || offer.carrier} variant="inst" />
        <span className="inst-family">{WORK_FAMILIES[workFamilyOf(j)]}</span><span className="inst-family">{JOB_KIND_LABELS[jobKindOf(j)]}</span>
        {offer.distance_m != null && <span className="inst-offer-dist">{fmtDistance(offer.distance_m)}</span>}
        {j.service_plan && <span className="inst-offer-plan">{j.service_plan}</span>}
      </div>
      <div className="inst-offer-actions">
        <button className="inst-btn" disabled={busy || expired} onClick={() => onAccept(offer)}>قبول</button>
        <button className="inst-btn inst-btn-ghost" disabled={busy} onClick={() => onDecline(offer)}>رد</button>
      </div>
    </div>
  );
}
